import { render } from "./UpgraderGame.vue?vue&type=template&id=4e8a2c6c&scoped=true"
import script from "./UpgraderGame.vue?vue&type=script&lang=js"
export * from "./UpgraderGame.vue?vue&type=script&lang=js"

import "./UpgraderGame.vue?vue&type=style&index=0&id=4e8a2c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8a2c6c"]])

export default __exports__